<form
	class="zk-flex zk-flex-col zk-gap-2"
	[formGroup]="appointmentForm"
	*ngIf="isFormRead"
>
	<div>
		<freud-select
			formControlName="professionalAddress"
			*ngIf="type === 'presencial'"
			[invalid]="
				!appointmentForm.controls.professionalAddress.valid &&
				appointmentForm.controls.professionalAddress.touched
			"
			[placeholder]="
				action === 'create'
					? ('APPOINTMENTS.LOCATION_PLACEHOLDER' | translate)
					: null
			"
			[options]="locations"
			optionValue="location"
			[label]="'APPOINTMENTS.LOCATION' | translate"
		></freud-select>
		<div
			class="locations__empty-state zk-mt-4"
			*ngIf="type === 'presencial' && !userHasLocations"
		>
			<span class="freud-icon freud-icon-info-circle freud-icon-md"></span>
			<div class="zk-flex zk-gap-4 zk-items-center">
				<span>{{ 'APPOINTMENTS.ADDRESS.EMPTY_STATE' | translate }}</span>
				<freud-button color="ghost" (click)="goToAddressPage()">{{
					'APPOINTMENTS.REGISTER' | translate
				}}</freud-button>
			</div>
		</div>
	</div>
	<div
		*ngIf="type === 'online'"
		class="zk-flex zk-justify-start zk-items-center zk-mb-4"
	>
		<div class="zk-flex zk-items-center">
			<label freud-typography fontType="bodySemibold1-2" class="freud-label">{{
				'APPOINTMENTS.REPOSITION.LABEL' | translate
			}}</label>
		</div>
		<div class="zk-flex zk-items-center zk-ml-4">
			<freud-radio-button
				ngDefaultControl
				[(ngModel)]="appointmentForm.controls.isReposition.value"
				[radioValue]="false"
				[label]="'APPOINTMENTS.REPOSITION.OPTION_1' | translate"
				formControlName="isReposition"
				name="isReposition"
				(valueChange)="changeIsReposition(false)"
			></freud-radio-button>
			<freud-radio-button
				ngDefaultControl
				[(ngModel)]="appointmentForm.controls.isReposition.value"
				[radioValue]="true"
				[label]="'APPOINTMENTS.REPOSITION.OPTION_2' | translate"
				formControlName="isReposition"
				name="isReposition"
				class="zk-ml-2"
				(valueChange)="changeIsReposition(true)"
			></freud-radio-button>
		</div>
	</div>
	<div
		class="zk-flex zk-gap-2 zk-mb-2"
		[ngClass]="{ 'zk-hidden': type === 'particular' }"
	>
		<contact-select
			ngDefaultControl
			[formControl]="appointmentForm.controls['contact']"
			(onContactChanged)="onContactChanged($event)"
			[invalid]="
				!appointmentForm.controls.contact.valid &&
				appointmentForm.controls.contact.touched
			"
			class="zk-w-1/2 md:zk-w-2/3"
		></contact-select>
		<freud-input-number
			ngDefaultControl
			currency="BRL"
			formControlName="price"
			mode="currency"
			[showButtons]="true"
			inputId="stacked"
			[invalid]="
				!appointmentForm.controls.price.valid &&
				appointmentForm.controls.price.touched
			"
			[disabled]="
				action === 'edit' || appointmentForm.controls.isReposition.value
			"
			[min]="0"
			[step]="5"
			[max]="1000"
			class="zk-w-1/2 md:zk-w-1/3"
			[label]="'APPOINTMENTS.VALUE' | translate"
		></freud-input-number>
	</div>
	<div *ngIf="appointmentForm.controls.isReposition.value" class="zk-mb-2">
		<appointments-no-show-select
			[disabled]="!appointmentForm.controls.contact.valid"
			[contactId]="appointmentForm.controls.contact.value"
			[invalid]="invalidAppointmentNoShowSelected"
			(onOptionChange)="selectAppointmentNoShow($event)"
		></appointments-no-show-select>
	</div>
	<div *ngIf="type !== 'particular'" class="zk-hidden">
		<label freud-typography fontType="bodySemibold1-2" class="freud-label">{{
			'APPOINTMENTS.DURATION' | translate
		}}</label>
		<div class="zk-flex zk-gap-2">
			<freud-radio-button
				ngDefaultControl
				[disabled]="action === 'edit'"
				formControlName="duration"
				[radioValue]="30"
				[(ngModel)]="appointmentForm.controls.duration.value"
				[name]="'duration'"
				[label]="'APPOINTMENTS.30_DURATION' | translate"
			></freud-radio-button>
			<freud-radio-button
				ngDefaultControl
				[disabled]="action === 'edit'"
				formControlName="duration"
				[(ngModel)]="appointmentForm.controls.duration.value"
				[radioValue]="50"
				[name]="'duration'"
				[label]="'APPOINTMENTS.50_DURATION' | translate"
			></freud-radio-button>
		</div>
	</div>
	<div *ngIf="type !== 'particular' && action === 'create'">
		<appointment-expiration-select
			id="appointment-expiration-select"
			[isUserPremium]="isUserPremium"
			[formGroup]="appointmentForm"
			(onChange)="onChangeExpiration($event)"
		></appointment-expiration-select>
	</div>
	<div
		class="zk-flex zk-gap-2 zk-w-full"
		*ngIf="type !== 'particular'"
	>
		<appointment-date-time
			[dates]="dates"
				class="zk-w-full"
				[index]="0"
			[minDate]="minDate"
			(onChangeDate)="onChangeDate(type, $event.event, 0)"
			(onChangeTime)="onChangeTime($event)"
		></appointment-date-time>
	</div>

	<div *ngIf="type === 'particular'">
		<freud-input-textarea
			ngDefaultControl
			[placeholder]="'APPOINTMENTS.OBSERVATIONS_PLACEHOLDER' | translate"
			formControlName="observations"
			[invalid]="
				!appointmentForm.controls.observations.valid &&
				appointmentForm.controls.observations.touched
			"
			[label]="'APPOINTMENTS.OBSERVATIONS' | translate"
		></freud-input-textarea>
		<form class="zk-flex zk-gap-2 zk-mt-3" formGroupName="particularDate">
			<freud-calendar
				ngDefaultControl
				[label]="'APPOINTMENTS.DATE' | translate"
				[inline]="false"
				formControlName="date"
				[minDate]="minDate"
				[required]="type === 'particular'"
				[showTime]="false"
				(onSelect)="onChangeDate(type, $event)"
				class="date-input zk-w-3/5"
			></freud-calendar>
			<div class="zk-flex zk-items-end zk-gap-2">
				<freud-calendar
					ngDefaultControl
					[label]="'APPOINTMENTS.TIME' | translate"
					[timeOnly]="true"
					[required]="type === 'particular'"
					formControlName="initialTime"
					[stepMinute]="10"
					[minDate]="minDate"
					[maxDate]="maxInitalDate"
					[invalid]="
						!appointmentForm.controls.particularDate['controls']['initialTime']
							.valid &&
						appointmentForm.controls.particularDate['controls']['initialTime']
							.touched
					"
					(valueChange)="onChangeTime($event, 'initial')"
					[inline]="false"
					id="initialTime"
					class="time-input zk-w-2/5"
				></freud-calendar>
				<span class="zk-mb-2 freud-label">Até</span>
				<freud-calendar
					ngDefaultControl
					[timeOnly]="true"
					formControlName="finalTime"
					[stepMinute]="10"
					[required]="type === 'particular'"
					(valueChange)="onChangeTime($event, 'final')"
					[minDate]="minEndDate"
					[maxDate]="maxEndDate"
					id="finalTime"
					[inline]="false"
					class="time-input zk-w-2/5"
				></freud-calendar>
			</div>
		</form>
		<div class="zk-flex zk-gap-2 zk-mt-3">
			<frequency-select
				ngDefaultControl
				[value]="appointmentForm.controls['frequencySelect'].value"
				(onSelectOption)="selectFrequencySelect($event)"
				[action]="action"
			></frequency-select>
		</div>
	</div>
	<appointment-recurrency
		*ngIf="canShowRecurrencyOptions()"
		[existsAsCustomer]="currentContact?.existsAsCustomer"
		[formGroup]="appointmentForm"
	>
	</appointment-recurrency>
	<!-- datas adicionadas na recorrencia customizada -->
	<div formArrayName="dates" *ngIf="type !== 'particular'">
		<form
			*ngFor="let date of dates.controls; let i = index"
		>
			<appointment-date-time
				class="zk-w-full"
				*ngIf="i > 0"
				[dates]="dates"
				[index]="i"
				[minDate]="minDate"
				(onChangeDate)="onChangeDate(type, $event.event, 0)"
				(onChangeTime)="onChangeTime($event)"
				(onRemove)="removeDate(i)"
			></appointment-date-time>
		</form>
	</div>
	<div
		*ngIf="
			canShowRecurrencyOptions() &&
			this.appointmentForm.get('recurrency').value === 'custom'
		"
		data-testid="recurrency-add-date-button"
		class="zk-flex zk-gap-4 zk-mt-3"
	>
		<freud-button
			*ngIf="!appointmentForm.controls.isReposition.value"
			color="secondary"
			class="zk-w-full zk-block appointment__button"
			(click)="addDate()"
			>{{ 'APPOINTMENTS.NEW_DATE' | translate }}</freud-button
		>
	</div>
</form>
